var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outbound-link"},[_c('h2',[_vm._v("You are about to visit an external url")]),_c('a',{staticClass:"preview-link",attrs:{"href":_vm.campaignUrl}},[_vm._v(_vm._s(_vm.link))]),_c('a',{staticClass:"btn is-secondary",attrs:{"href":_vm.campaignUrl}},[_vm._v("Proceed")])])
}
var staticRenderFns = []

export { render, staticRenderFns }